import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TherapistRoutingModule } from './therapist-routing.module';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { SharedModule } from '../shared/shared.module';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { FlatpickrModule } from 'angularx-flatpickr';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { AccordionModule } from 'primeng/accordion';
import { MenuModule } from 'primeng/menu';
import { TabViewModule } from 'primeng/tabview';
import { WeekViewSchedulerModule } from './my-appointments/week-view-scheduler/week-view-scheduler.module';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TherapistMyProfileComponent } from 'src/app/therapist/my-profile/therapist-my-profile.component';
import { TherapistMyChangePasswordComponent } from './my-change-password/therapist-my-change-password.component';
import { MyAvailabilityNewComponent } from './my-availability-new/my-availability-new.component';
import { PipesModule } from '../pipes/pipes/pipes.module';
import { MyAppointmentsNewComponent } from './my-appointments-new/my-appointments-new.component';
import { SidebarModule } from 'primeng/sidebar';
import { GoogleMapsModule } from '@angular/google-maps';
import { PatientDetailSidebarComponent } from './patient-detail-sidebar/patient-detail-sidebar.component';
import { WeekViewMobileComponent } from './week-view-mobile/week-view-mobile.component';
import { SchedulerModule } from 'angular-calendar-scheduler';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { DrawerModule } from 'primeng/drawer';
import { PatientBulkStatusUpdateComponent } from './my-appointments/patient-bulk-status-update/patient-bulk-status-update.component';
import { PatientStatusUpdateComponent } from './my-appointments/patient-status-update/patient-status-update.component';
@NgModule({
  declarations: [
    TherapistMyProfileComponent,
    TherapistMyChangePasswordComponent,
    MyAvailabilityNewComponent,
    MyAppointmentsNewComponent,
    WeekViewMobileComponent,
    PatientStatusUpdateComponent,
    PatientBulkStatusUpdateComponent
  ],
  imports: [
    CommonModule,
    TherapistRoutingModule,
    FormsModule,
    DropdownModule,
    SharedModule,
    NgbModalModule,
    ProgressSpinnerModule,
    FlatpickrModule.forRoot(),
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
    AccordionModule,
    TabViewModule,
    MenuModule,
    WeekViewSchedulerModule,
    PipesModule,
    SidebarModule,
    GoogleMapsModule,
    SchedulerModule.forRoot({ locale: 'en', headerDateFormat: 'daysRange' }),
    DialogModule,
    TooltipModule,
    DrawerModule,
  ],

  exports: [DialogModule]
})
export class TherapistModule {}
